export default __webpack_public_path__ + "static/media/arrow-circle.c6a3fe4c.png";